import { render, staticRenderFns } from "./AddLeak.vue?vue&type=template&id=401671d4&scoped=true"
import script from "./AddLeak.vue?vue&type=script&lang=js"
export * from "./AddLeak.vue?vue&type=script&lang=js"
import style0 from "./AddLeak.vue?vue&type=style&index=0&id=401671d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401671d4",
  null
  
)

export default component.exports